import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { ButtonBase } from '../Button';

export const StyledForm = styled('form')`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(41), 164)};
        }
	`}
`;

export const StyledSubmitButton = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(3), 12)};

        ${theme.breakpoints.up('desktop')} {
            display: block;
            width: ${theme.tggSpacing(rem(17.7), 71)};
            margin: ${theme.tggSpacing([rem(4), 'auto', rem(1), 'auto'], [16, 'auto', 4, 'auto'])};
        }
	`}
`;
